;(function() {
  // Consultation
  window.addEventListener('load', (event) => {
    if (document.body.classList.contains('page-id-87')) {
      fathom.trackGoal('1RBJ5FA5', 0)
    }
  })
  const consultationForm = document.querySelector('#gform_1')
  const consultationPhones = document.querySelectorAll(
    '.fathom__consult-phone a'
  )

  if (consultationForm) {
    consultationForm.addEventListener('submit', () => {
      fathom.trackGoal('WMPP2CZT', 0)
    })
  }
  if (consultationPhones && consultationPhones.length) {
    consultationPhones[0].addEventListener('click', () => {
      fathom.trackGoal('J4M81MCQ', 0)
    })
    consultationPhones[1].addEventListener('click', () => {
      fathom.trackGoal('E8UEK3NY', 0)
    })
  }

  // Contact Us
  const contactAddress = document.querySelector('.fathom__contact-address a')
  const contactPhones = document.querySelectorAll('.contact-phone a')
  const afterHours = document.querySelectorAll('.fathom__contact-after-hours a')

  if (contactAddress) {
    contactAddress.addEventListener('click', () => {
      fathom.trackGoal('439GIMVD', 0)
    })
  }
  if (contactPhones && contactPhones.length) {
    contactPhones[0].addEventListener('click', () => {
      fathom.trackGoal('AUUYDB66', 0)
    })
    contactPhones[1].addEventListener('click', () => {
      fathom.trackGoal('BUQIXFES', 0)
    })
  }
  if (afterHours && afterHours.length) {
    afterHours[0].addEventListener('click', () => {
      fathom.trackGoal('OIEIQLQH', 0)
    })
    afterHours[1].addEventListener('click', () => {
      fathom.trackGoal('ZW4UNSW9', 0)
    })
  }

  // Online Form Contact Us
  const onlineForm = document.querySelector('#gform_2')
  if (onlineForm) {
    onlineForm.addEventListener('submit', () => {
      fathom.trackGoal('CEDUFFJ9', 0)
    })
  }

  // Homepage
  const benefitsRenting = document.querySelector('.fathom__home-rent-benefits')
  const consultationRequest = document.querySelector(
    '.fathom__home-consult-request'
  )

  if (benefitsRenting) {
    benefitsRenting.addEventListener('click', () => {
      fathom.trackGoal('5UA1B2FD', 0)
    })
  }
  if (consultationRequest) {
    consultationRequest.addEventListener('click', () => {
      fathom.trackGoal('NOZMUHZ9', 0)
    })
  }

  // Bill Pre-Auth
  const preAuthForm = document.querySelector('.fathom_pre-auth a')
  if (preAuthForm) {
    preAuthForm.addEventListener('click', () => {
      fathom.trackGoal('HYYVEOET', 0)
    })
  }
})()
